import React from 'react';

const DropdownPlusIcon = (props) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.1" filter="url(#filter0_b_11810_87211)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z"
        fill="#F99D31"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00153 2C4.74957 2 4.54531 2.20154 4.54531 2.45016V4.55L2.45622 4.55C2.20426 4.55 2 4.75154 2 5.00016C2 5.24878 2.20426 5.45032 2.45622 5.45032L4.54531 5.45032V7.54984C4.54531 7.79846 4.74957 8 5.00153 8C5.2535 8 5.45775 7.79846 5.45775 7.54984V5.45032L7.54378 5.45032C7.79574 5.45032 8 5.24878 8 5.00016C8 4.75154 7.79574 4.55 7.54378 4.55L5.45775 4.55V2.45016C5.45775 2.20154 5.2535 2 5.00153 2Z"
      fill="#FB9318"
    />
    <defs>
      <filter
        id="filter0_b_11810_87211"
        x="-54.3656"
        y="-54.3656"
        width="118.731"
        height="118.731"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="27.1828" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_11810_87211"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_11810_87211"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default DropdownPlusIcon;
